import { gql } from '@/modes/company/gql';

export const GET_NOTICE_IDS = gql(`
  query GetNoticeIds(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    notices(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
      groupBy: ["id"]
    ) {
      id
    }
  }
`);

export const GET_NOTICES = gql(`
  query GetNotices(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    notices(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
      id
      type
      subject
      archived
    }
  }
`);
